import { render, staticRenderFns } from "./NewPassword.vue?vue&type=template&id=8d63987a&scoped=true&"
import script from "./NewPassword.vue?vue&type=script&lang=ts&"
export * from "./NewPassword.vue?vue&type=script&lang=ts&"
import style0 from "./NewPassword.vue?vue&type=style&index=0&id=8d63987a&scoped=true&lang=css&"
import style1 from "./NewPassword.vue?vue&type=style&index=1&id=8d63987a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d63987a",
  null
  
)

export default component.exports